import { ChangeDetectorRef, Component, EventEmitter, NgZone, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { localStorageService } from '../localstorage.service';
import { MainService } from '../main.service';
import { countryType, SharedService, timezoneType } from '../shared.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TwilioService } from '../twilio.service';
import { SocketsService } from '../socket/socket.service';
import { DomSanitizer } from '@angular/platform-browser';
// import { DebtRecoveryService } from '../../pages/debt-recovery/debt-recovery.service';
import { DialerService } from '../dialer.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  animations: [ // 👈 This is required!
    trigger('drawerState', [
      state('open', style({ transform: 'translateX(0%)' })),  // Visible
      state('closed', style({ transform: 'translateX(100%)' })),  // Hidden
      transition('open <=> closed', animate('300ms ease-in-out'))
    ])
  ]
})
export class MainLayoutComponent implements OnInit, OnChanges, OnDestroy {
  [x: string]: any;
  menuList: any = [];
  timezoneList: any = [];
  selectedTimezone: any;

  countryList: any = [];
  isCollapsed = true;
  notifications: Notification[] = [];
  selectedCountry: any;

  isDummy = false;
  profileData: any;
  currentTime = new Date();
  call_logs_data: any = [];
  searchNavBarShow = false;
  admin_profile: any;
  private _users: any;
  role: any;
  
  // notifications variables
  isCollapsedNotifications = true;
  unread_count: number = 0;
  notification_count = 0;
  notificationCount = 0;
  count: number = 0;
  notificationTimezoneName: any = '';
  private sub = new Subscription();

  role_id:any;
  call: boolean = false;
  alert: boolean = false;
  logs: boolean = false;
  alertdata: any;
  unmappedLogs: any[] = [];
  mappedLogs: any[] = [];
  unmappedMessages: any[] = [];
  unmappedEmails: any[] = [];
  mappedMessages: any[] = [];
  mappedEmails: any[] = [];
  groupedEmailResult: GroupedEmail[] = [];
  groupedSMSResult: any[] = [];
  groupedMappedCalls: any[] = [];
  mappedLogsCalls: any[] = [];
  groupedUnmappedMessages: any[] = [];
  account_id:any;
  hasNewActivity = false;
  hasNewUnmapped = false;
  hasNewMapped = false;
  missedCallsCount: number = 0;
  mappedMissedCallsCount: number = 0;
  unmappedMissedCallsCount: number = 0;
  showMissedCalls = false;

  // Communication Center search (emails -> email id, messages/calls -> phone number)
  communicationSearch: string = '';

  // Counts driven by CALL_ALERT socket events (resettable from Communication Center)
  mappedCallAlertCount = 0;
  unmappedCallAlertCount = 0;
  
  accountId:any;
  splitReqId:any;
  unmappedCalls: any[] = [];
  mappedCalls: any[] = [];
  
  Subtabs = {
    Emails: 'emails',
    Messages: 'messages', 
    calls: 'calls',
  } as const;
  selectedSubTab: any = this.Subtabs.Emails;
  twilioData : any = this._local.customGetItem('twillio') ? this._local.customGetItem('twillio') : '';
  selectedSubMenu: any;
  tabs = {
    unmapped: 'Unmapped',
    mapped: 'Mapped',
  }
  modalRef!: BsModalRef;
  @ViewChild('loginAuthentication', {static : false}) restricted!: TemplateRef<any>;

  @Input() modaldata: any;
  selectedTab: string = this.tabs.mapped;
  logs_data: any =[];
  emailViewerOpen = false;
  selectedEmailPreview: any = null;
  selectedEmailPreviewHtml = '';
  smsViewerOpen = false;
  selectedSmsThread: any = null;
  showGoogleAuth = false;
  googleAuthLoading = false;
  private authPopupTimer: any;
  constructor(private _router: Router,
    private modalService: BsModalService,
    private _local : localStorageService,
     public _main: MainService,
      public _shared: SharedService,
       private route: ActivatedRoute,
        private _api: ApiService,
         public twilio: TwilioService,
          public bsModalRef: BsModalRef,
           private _socket: SocketsService,
            private cdRef: ChangeDetectorRef,
            public dialer: DialerService,
            private sanitizer: DomSanitizer
          ) {}

  ngOnInit() {
    window.addEventListener('storage', this.onGmailAuthResult);
    this.role_id = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').role_id) : 0;
    this.CommunicationApi();
    this._socket.on('NEW_EMAIL', (data: any) => {
      if (data) {
        data.type = 'NEW_EMAIL';
        data.isNew = true;
        data.account_id = data.split_req_id?.[0]?.account_id ?? null;
        data.created = data.created || new Date().toISOString();
        this.showAlert(data);
        this.hasNewActivity = true; 
        this.logs = true;

        if (data.account_id) { 
          this.hasNewMapped = true;
          this.mappedEmails = [data, ...this.mappedEmails];
          this.groupedEmailResult = this.groupedEmails();
        } else {
          this.hasNewUnmapped = true;
          this.unmappedEmails = [data, ...this.unmappedEmails];
        }
        this.cdRef.detectChanges();
      }
    });

    this._socket.on('SMS_ALERT', (data: any) => {
      if (data){
      data.type = 'SMS';
      data.alertType = 'SMS_ALERT';
      data.isNew = true;
      data.from_number = data.from_number ?? data.split_req_id?.[0]?.from_number ?? null;
      data.account_id = data?.account_id ?? null;
      data.content = data?.content ?? null;
      data.created = data.created || new Date().toISOString();
      this.hasNewActivity = true;

      if (data.split_req_id?.length) {
        this.hasNewMapped = true;
        this.mappedMessages = [data, ...this.mappedMessages];
        this.groupedSMSResult = this.groupedSms();
      } else {
        this.hasNewUnmapped = true;
        this.unmappedMessages = [data, ...this.unmappedMessages];
        this.groupUnmappedMessages();
      }
        console.log(data, 'SMS_ALERT data');
        this.cdRef.detectChanges();
    }
    });

    this._socket.on('CALL_ALERT', (data: any) => {
      console.log('CALL_ALERT received:', data);
      if (data) {
        // Handle data wrapped in 'data' array or direct array
        let callData = data;
        if (data.data && Array.isArray(data.data)) {
          callData = data.data[0];
        } else if (Array.isArray(data)) {
          callData = data[0];
        }
        
        console.log('callData extracted:', callData);
        
        if (callData) {
          callData.type = 'CALL';
          callData.isNew = true;
          callData.created = callData.created || new Date().toISOString();
          this.hasNewActivity = true;

          if (callData.split_req_id) {
            console.log('Adding to mapped calls');
            this.mappedCalls = [callData, ...this.mappedCalls];
            this.groupedMappedCalls = this.groupCalls();
            console.log('groupedMappedCalls after update:', this.groupedMappedCalls);
            this.mappedCallAlertCount += 1;
          } else {
            console.log('Adding to unmapped calls');
            this.unmappedCalls = [callData, ...this.unmappedCalls];
            console.log('unmappedCalls after update:', this.unmappedCalls);
            this.unmappedCallAlertCount += 1;
          }
          this.calculateMissedCallsCount();
          this.cdRef.detectChanges();
        }
      }
    });



    this.admin_profile = this._local.customGetItem('admin_profile');
    console.log("twilio_data", this.twilioData)
    console.log('twillio data', this.twilioData)
    const phone_no = this.admin_profile.admin_mobile && Array.isArray(this.twilioData) && this.twilioData.some((x: any) => x.twilio_mobile === this.admin_profile.admin_mobile) ? this.admin_profile.admin_mobile : '';
    if (phone_no && !this.twilio.twilioInitiated) {
      if (this.role_id != 13 || this.role_id != 1 || this.role_id != 4) {
        this.twilio.initTwilio(phone_no);
      }
    }
    this.getRoles();
    this._main.menu$.subscribe(menus => {
      if (menus && menus.length) {
        this._shared.routerAuth.routeAuth(menus);
        this.menuList = menus;
        let all_menu: any = [];
        this.menuList.forEach((item: any) => {
          // if (item['only_path'] === '1') {
          //   main_menu.splice(index, 1);
          // }
          let submenu: any = [];
          if (item['submenu'] && item['submenu'].length > 0) {
            item['submenu'].forEach((sub: any) => {
              if (sub['only_path'] !== '1') {
                if (!submenu) {
                  submenu = [];
                }
                submenu.push(sub);
              }
            });
          }
          item.submenu = submenu;
          if (item['only_path'] !== '1') {
            all_menu.push(item);
          }
        });
    
        all_menu.forEach((item: any) => {
          if (item.submenu) {
            item.submenu = item.submenu.sort((a: any, b: any) => {
              return a.in_order - b.in_order;
            });
            if (item.submenu.length === 0) {
              item.submenu = null;
            }
          }
        });
        this.menuList = all_menu;
      }
    })
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
    const queryParams = { ...this.route.snapshot.queryParams };
    this.isDummy = queryParams && queryParams['is_dummy'] == 1 ? true : false;
    this._main.country_data$.subscribe((counList) => {
      this.countryList = counList;
      const countryId = Number(queryParams['country_id'])
        || Number(this._local.customGetItem('country_id'))
        || counList[0]?.country_id;
      let item = counList.find(
        (country: countryType) => country.country_id === countryId
      );
      item = item && item.country_id ? item : counList[0];
      if (item && item.country_id) {
        this.selectedCountry = item;
        this._shared.mask = item.country_phone_format;
      }
      this.updateQueryParams();
    })
    this._main.timezoneList$.subscribe(tZList => {
      if (tZList && tZList.length) {
        // static US country set
        this.timezoneList = tZList;
        // this.timezoneList = tZList.filter((item: any) => item.country_id === 1);
        let item = tZList.find(
          (timezone: timezoneType) =>
            timezone['val'] ===
            ((queryParams && queryParams['timezone']) || '-800')
        );
        item = item && item.tz_id ? item : tZList[0];
        this.selectedTimezone = item;
        this._shared.timezone = item['val'];
        this._shared.timezoneName$.next(item['name']);
        this.notificationTimezoneName = item['offset']
        this.updateQueryParams();
        // this._shared.timezoneName$.next(timeZ['name']);
        // this._shared.zone$.next(timeZ['zone']);
      }
    })
    this.profileData = this._local.customGetItem('admin_profile');
    this._main.active_for_chat = this.profileData.active_for_chat;

    this.sub = this._shared.notificationCount$.subscribe(count => {
      if (this.notification_count != count) {
        this.getLiveNotifications()
      }
      this.notification_count = count;
    });

    this.getLiveNotifications()
    this.twilio.opencalling$?.subscribe((data: any) => {
      if (data) {
        this.call = true;
      } else {
        this.call = false;
      }
    });
    // this.twilio.callended$?.subscribe((data: any) => {
    //   if (data) {
    //     this.call = false;
    //     // this.twilio.callended$?.next(false);
    //   }
    // });
  }
  ngAfterViewInit(): void {
    const is_restricted = localStorage.getItem('is_restricted') === '1';
    if (this.modalRef?.id) {
      return;
    }
    if (!is_restricted && !this.modalRef?.id) {
      this.openModalRestrictedModal(this.restricted);
      this.disableInspect();
      return;
    }
    this.checkGmailStatus();
  }
  
  openModalRestrictedModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'restrict__modal modal-dialog-centered',
      backdrop: 'static'
    });
  
    // Wait for backdrop to appear
    setTimeout(() => {
      const backdrop = document.querySelector('.modal-backdrop');
      backdrop?.classList.add('background-blur');
  
      // fallback: blur body if modal-backdrop not found
      if (!backdrop) {
        document.body.classList.add('background-blur');
      }
    }, 50);
  }
  
  

  disableInspect() {
    document.addEventListener("contextmenu", this.preventRightClick);
    document.addEventListener("keydown", this.preventShortcuts);
  }
   enableInspect() {
    document.removeEventListener("contextmenu", this.preventRightClick);
    document.removeEventListener("keydown", this.preventShortcuts);
  }
  preventRightClick = (e: Event) => {
    e.preventDefault();
  }

  preventShortcuts = (e: KeyboardEvent) => {
  if (
    e.key === "F12" ||
    e.key === "Escape" ||
    (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
    (e.ctrlKey && e.key.toUpperCase() === "U") 
    ) {
      e.preventDefault();
      e.stopPropagation(); 
    }
  }
  proceedToLogin() {
    localStorage.setItem('is_restricted', '1');
    this.modalRef.hide();
  
    setTimeout(() => {
      document.querySelector('.modal-backdrop')?.classList.remove('background-blur');
      document.body.classList.remove('background-blur');
    }, 50);

    this.enableInspect();
    // ngAfterViewInit skips the Gmail check while this modal is up, so run it once acknowledged.
    this.checkGmailStatus();
  }
  
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['alertdata']) {
      this.alert = true
    }
  }
  CommunicationApi() {
    this._api
      .api({}, 'finance/get_email_sms_logs', 'post')
      .subscribe((resp) => {
        this.logs_data = Object.values(resp.result || {}).sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime());
        this.call_logs_data = Object.values(resp.calls || {}).sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime());
        console.log(this.logs_data);
        this.unmappedLogs = this.logs_data.filter(
          (x: { split_req_id: any }) => !x.split_req_id
        );
        this.unmappedCalls = this.call_logs_data.filter(
          (x: { split_req_id: any }) => !x.split_req_id
        );
        this.unmappedEmails = this.unmappedLogs.filter(
          (x) => x.type === 'EMAIL'
        );
        this.unmappedMessages = this.unmappedLogs.filter(
          (x) => x.type === 'SMS'
        );
        this.mappedLogsCalls = this.call_logs_data.filter(
          (x: { split_req_id: any }) => x.split_req_id
        );
        this.groupUnmappedMessages();
        this.mappedLogs = this.logs_data.filter(
          (x: { split_req_id: any }) => x.split_req_id
        );
        this.mappedEmails = this.mappedLogs.filter((x) => x.type === 'EMAIL');
        this.mappedMessages = this.mappedLogs.filter((x) => x.type === 'SMS');
        this.mappedCalls = this.mappedLogsCalls.filter((x) => x.type === 'CALL');
        this.calculateMissedCallsCount();
        this.groupedEmailResult = this.groupedEmails();
        this.groupedSMSResult = this.groupedSms();
        this.groupedMappedCalls = this.groupCalls();
        console.log(
          'Test',
          this.unmappedLogs,
          this.unmappedEmails,
          this.unmappedMessages,
          this.unmappedCalls,
          this.mappedEmails,
          this.mappedLogs,
          this.mappedMessages
        );
      });
  }
   toggleDrawerNotifications() {
    this.isCollapsedNotifications = !this.isCollapsedNotifications;
  }                                                                                                                                           
calculateMissedCallsCount() {
    this.mappedMissedCallsCount = this.mappedCalls?.filter((call: any) => 
      call.call_status === 'no-answer' || call.call_status === 'missed'
    ).length || 0;

    this.unmappedMissedCallsCount = this.unmappedCalls?.filter((call: any) => 
      call.call_status === 'no-answer' || call.call_status === 'missed'
    ).length || 0;

    this.missedCallsCount = this.mappedMissedCallsCount + this.unmappedMissedCallsCount;
  }

  toggleShowMissedCalls() {
    // When "Reset" is clicked (i.e., we are currently showing missed calls),
    // reset the CALL_ALERT-driven counters back to zero.
    if (this.showMissedCalls) {
      this.mappedCallAlertCount = 0;
      this.unmappedCallAlertCount = 0;

      // Clear "new" highlight for call alerts in the Communication Center.
      for (const call of this.mappedCalls || []) {
        call.isNew = false;
      }
      for (const call of this.unmappedCalls || []) {
        call.isNew = false;
      }
    }

    this.showMissedCalls = !this.showMissedCalls;
  }

  setMissedCallsFilter(show: boolean) {
    if (this.showMissedCalls && !show) {
      // Switching from Missed to All -> Reset counters
      this.mappedCallAlertCount = 0;
      this.unmappedCallAlertCount = 0;
      
      for (const call of this.mappedCalls || []) call.isNew = false;
      for (const call of this.unmappedCalls || []) call.isNew = false;
    }
    this.showMissedCalls = show;
  }

  getMissedCallsLabel(count: number) {
    return count > 0 ? `Missed Calls (${count})` : 'Missed Calls';
  }

  getDisplayedCalls() {
    let allCalls = [...this.mappedCalls, ...this.unmappedCalls];
    
    if (this.showMissedCalls) {
      return allCalls.filter((call: any) => 
        call.call_status === 'no-answer' || call.call_status === 'missed'
      );
    }
    return this.mappedCalls;
  }

  getDisplayedUnmappedCalls() {
    if (this.showMissedCalls) {
      return this.unmappedCalls.filter((call: any) => 
        call.call_status === 'no-answer' || call.call_status === 'missed'
      );
    }
    return this.unmappedCalls;
  }

  getDisplayedGroupedMappedCalls() {
    if (this.showMissedCalls) {
      return this.groupedMappedCalls.filter((group: any) => 
        group.call_status === 'no-answer' || group.call_status === 'missed'
      );
    }
    return this.groupedMappedCalls;
  }

  selectSubTab(subTab: any) {
    this.selectedSubTab = subTab;
    this.communicationSearch = '';
  }

  clearCommunicationSearch() {
    this.communicationSearch = '';
  }

  get searchPlaceholder(): string {
    return this.selectedSubTab === this.Subtabs.Emails
      ? 'Search by email'
      : 'Search by number';
  }

  // Emails are matched on the email id, messages/calls on the phone number.
  private matchesEmail(value: any, term: string): boolean {
    return String(value ?? '').toLowerCase().includes(term);
  }

  private matchesNumber(values: any[], term: string): boolean {
    const digits = term.replace(/\D/g, '');
    if (!digits) {
      return values.some((v) => String(v ?? '').toLowerCase().includes(term));
    }
    return values.some((v) => String(v ?? '').replace(/\D/g, '').includes(digits));
  }

  private get searchTerm(): string {
    return (this.communicationSearch || '').trim().toLowerCase();
  }

  // Unmapped
  getFilteredUnmappedEmails() {
    const term = this.searchTerm;
    if (!term) return this.unmappedEmails;
    return this.unmappedEmails.filter((x: any) =>
      this.matchesEmail(x?.from_email, term)
    );
  }

  getFilteredUnmappedMessages() {
    const term = this.searchTerm;
    if (!term) return this.groupedUnmappedMessages;
    return this.groupedUnmappedMessages.filter((group: any) =>
      this.matchesNumber([group?.from_number], term)
    );
  }

  getFilteredUnmappedCalls() {
    const calls = this.getDisplayedUnmappedCalls();
    const term = this.searchTerm;
    if (!term) return calls;
    return calls.filter((call: any) =>
      this.matchesNumber([call?.from_number, call?.to_number], term)
    );
  }

  // Mapped
  getFilteredMappedEmails() {
    const term = this.searchTerm;
    if (!term) return this.groupedEmailResult;
    return this.groupedEmailResult.filter((group: any) =>
      this.matchesEmail(group?.from_email, term)
    );
  }

  getFilteredMappedMessages() {
    const term = this.searchTerm;
    if (!term) return this.groupedSMSResult;
    return this.groupedSMSResult.filter((group: any) =>
      this.matchesNumber([group?.from_number], term)
    );
  }

  getFilteredMappedCalls() {
    const groups = this.getDisplayedGroupedMappedCalls();
    const term = this.searchTerm;
    if (!term) return groups;
    return groups.filter((group: any) =>
      this.matchesNumber([group?.from_number, ...(group?.to_numbers || [])], term)
    );
  }
  toggleChange() {
    this.isDummy = !this.isDummy;
    this.updateQueryParams();
  }

  showAlert(data: any) {
    this.alertdata = { ...data };
    this.alert = true;
    this.call = false; // optional if you want to make sure only one type shows
    this.cdRef.detectChanges(); // ensure Angular updates the view
  }

  Redirect(split_req_id: any, type: string) {
  if (!split_req_id) return;

  const finalSplit = Array.isArray(split_req_id)
    ? split_req_id[0]?.split_req_id ?? split_req_id[0]
    : split_req_id;

  this.isCollapsed = !this.isCollapsed;

  // Details page picks this up whether it's already open (same or other account) or freshly created
  this._shared.commsRedirect$.next({ split_req_id: finalSplit, subtab: type });
  this._router.navigate(['/app/debt-recovery/details', this._shared.encodeId(finalSplit)]);
}

notificationclose() {
  this.alert = false;
  this.call = false;
  this.alertdata = null;
  this.cdRef.detectChanges();
}

  getRoles() {
    this._api.api({}, 'user/admin_role_list', 'get')
      .subscribe((data: any) => {
        this._users = data.data;
        console.log(this._users, 'jjjjjjj')
        const result = this._users?.find((item: { role_id: any; }) => item?.role_id === this.admin_profile?.role_id);
        this.role = result?.role_name;
      });
  }

  changeCountry(country: any) {
    if (country) {
      this.selectedCountry = country;
      this._shared.mask = country.country_phone_format;
      this._main.selected_country$.next(country);
      this._main.currencySymbol$.next(country.display_logo || '$');
      this._main.setCountryContext(country);
      this.updateQueryParams();
    }
  }

  changeTimezone(timezone: any) {
    this.selectedTimezone = timezone;
    this._shared.timezone = timezone['val'];
    this._shared.timezoneName = timezone['name'];
    this._shared.timezoneName$.next(timezone['name']);
    this.notificationTimezoneName = timezone['offset']
    this._shared.updated_timezone$.next(timezone['val']);
    this.updateQueryParams();
  }

  toggleMenu(selectedTap: any, activeParent?: any) {
    if (selectedTap.submenu) {
      selectedTap.isOpen = !selectedTap.isOpen;
    } else {
      selectedTap.isOpen = true;
      if (selectedTap.path == '/app/chatsupport') {
        this._main.global_bar = false;
      } else {
        this._main.global_bar = true;
      }
      this._router.navigate([selectedTap.path]);
      setTimeout(() => {
        if (this._router.url.includes(selectedTap.path)) {
          this.selectedSubMenu = selectedTap;
        } else {
          this.selectedSubMenu = {};
        }
      }, 100);
    }
    this.menuList.forEach((menu: any) => {
      if (menu === selectedTap) {
        menu.isOpen = !!selectedTap.isOpen;
      } else {
        menu.isOpen = menu.path == activeParent?.path ? true : false;
      }
    });
  }

  openNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(0%)';
    }
  }

  closeNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(-100%)';
    }
  }

  showLogoutModal() {
    const modelRef = this.modalService.show(ConfirmationModalComponent, {
      initialState: {
        extra_data: {
          label: 'Are you sure you want to Logout ?',
          hideNotes: true
        }
      },
      class: 'modal-dialog-centered',
    })
    modelRef.content?.passEntry.subscribe(response => {
      if (response.success) {
        this._api.api({}, 'auth/logout').subscribe((resp: any) => {
          if (!resp.is_error) {
            this._local.customClearAllItems();
            localStorage.removeItem('is_restricted');
            this.twilio.unregisterDevice();
            this._router.navigate(['login']);
          }
        })
        // let data = {
        //   admin_id: user.admin_id
        // };
        // this._api.api(data, 'send_credentials_to_admin').subscribe((data: any) => { 
        //   console.log(data); 
        // });
      }
    })
  }

  // Method to add or update the query parameters
  updateQueryParams(): void {
    // Preserve the selected timezone while dropdown data is still loading.
    const queryParams = { ...this.route.snapshot.queryParams };
    const timezone = (this.selectedTimezone && this.selectedTimezone['val']) || queryParams['timezone'] || this._local.customGetItem('timezone') || '-800';

    this._local.customSetItem('is_dummy', this.isDummy ? '1' : '0');
    if (this.selectedCountry) {
      this._main.setCountryContext(this.selectedCountry);
      if (this.selectedCountry.country_id) {
        queryParams['country_id'] = String(this.selectedCountry.country_id);
      }
      const cocuId = this._local.customGetItem('cocu_id');
      if (cocuId != null && cocuId !== '') {
        queryParams['cocu_id'] = String(cocuId);
      }
    }
    this._local.customSetItem('timezone', timezone);

    queryParams['is_dummy'] = this.isDummy ? 1 : 0;
    queryParams['timezone'] = timezone;

    // Use router to update the query params without reloading the page
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',  // Merge with existing query params
      replaceUrl: true               // Replace URL in history without adding a new entry
    });
  }

  toggleChangeChat() {
    this._main.active_for_chat = !this._main.active_for_chat;
    this._api.api({ active_for_chat: this._main.active_for_chat ? 1 : 0 }, `chatbot/update_admin_chat_status`, "post").subscribe((res) => {
      if (res.is_error == 0) {
        this._shared.customPopups(res.msg, res.is_error);
      }
      else {
        this._shared.customPopups(res.msg, res.is_error);
      }
    })
  }
  groupedCalls() {
  const map = new Map<string, any>();

  for (const i of this.mappedCalls ?? []) {
    const number =
      i?.direction === 'inbound'
        ? String(i?.to_number)
        : String(i?.from_number);

    if (!map.has(number)) {
      map.set(number, {
        accounts: [],
        created: i.created,
        call_status: i.call_status,
        isMissed: false,
        showAllAccounts: false
      });
    }

    const g = map.get(number);

    // 👉 Keep latest call info
    if (new Date(i.created) > new Date(g.created)) {
      g.created = i.created;
      g.call_status = i.call_status;
    }

    // 👉 Missed call logic
    if (i.call_status === 'no-answer' || i.call_status === 'missed') {
      g.isMissed = true;
    }

    // 👉 Unique account mapping
    if (i?.admin_id && i?.split_req_id) {
      const exists = g.accounts.some(
        (a: any) =>
          a.adminId === i.admin_id &&
          a.splitReqId === i.split_req_id
      );

      if (!exists) {
        g.accounts.push({
          adminId: i.admin_id,
          splitReqId: i.split_req_id
        });
      }
    }
  }

  // 👉 Final structure (same style as your emails)
  return [...map.entries()].map(([number, d]) => ({
    number,
    created: d.created,
    call_status: d.call_status,
    isMissed: d.isMissed,
    accounts: d.accounts,
    showAllAccounts: d.showAllAccounts
  }));
}

  // notifications functions
  markRead(id:any, index:any){
    let params: any = {};
    if(id){
        params['an_id'] = id;
    }
    this._api.api(params,'user/mark_all_notifications_read', "post")
    .subscribe((data:any)=>{
      if (this.notifications[index]) {
        this.notifications[index].read_at = `${new Date()}`;
        this.unread_count--;
        this.notification_count--;
        this._shared.setNotificationCount(this.notification_count);
      }      
    })
  }

  redirectToNotification(notification: Notification, index: number){
    this.isCollapsedNotifications= !this.isCollapsedNotifications;
    const meta_data = typeof(notification.metadata) == 'string' ? JSON.parse(notification.metadata) : notification.metadata;
    const reqid = meta_data.req_id || meta_data.training_id || meta_data.request_id;

    if(notification.read_at === null){
      this.markRead(notification.an_id, index);
    }

    const redirect_route = meta_data?.training_id ? '/app/training/details' : '/app/assignments/my-assignments';
    this._router.navigate(
      [redirect_route, reqid] );
  }

  viewMore(){
    this.isCollapsedNotifications = !this.isCollapsedNotifications;
    this._router.navigate(['/app/notifications']);
  }

  toggleDrawer() {
  this.isCollapsed = !this.isCollapsed;
  if (!this.isCollapsed) {
    // Drawer opened → remove NEW badge
    this.hasNewActivity = false;
  }
}
  getLiveNotifications(){
    let params: any = { limit: 5, offset: 0 };

    this._api.api(params, 'user/fetch_admin_notifications', 'get')
}
markAllAsRead() {
    this._api.api({}, 'user/mark_all_notifications_read', 'post').subscribe(
      (data: any) => {
        if (data && data.is_error === 0) {
          //Call the notification API again
          this.unread_count = 0;
          this._shared.setNotificationCount(data.unread_count || 0);
          this.getLiveNotifications();
        }
      },
      (error) => {
        console.error('Error marking notifications as read:', error);
      }
    );
  }

groupedEmails() {
  const map = new Map<string, any>();

  for (const i of this.mappedEmails ?? []) {
    const email = String(i?.from_email);

    if (!map.has(email)) {
      map.set(email, {
        accounts: [],    //ONE ARRAY
        created: i.created,
        isNew: false,
        showAllAccounts: false
      });
    }

    const g = map.get(email);

    if (i.isNew) {
      g.isNew = true;
    }

    
    if (i?.account_id && i?.split_req_id) {
      const exists = g.accounts.some(
        (a: any) => a.accountId === i.account_id
      );

      if (!exists) {
        g.accounts.push({
          accountId: i.account_id,
          splitReqId: i.split_req_id
        });
      }
    }
  }
  return [...map.entries()].map(([from_email, d]) => ({
    from_email,
    created: d.created,
    accounts: d.accounts,
    isNew: d.isNew,
    showAllAccounts: d.showAllAccounts
  }));
}

  openEmailView(email: any, event: any) {
    event.stopPropagation();
    email.isNew = false;
    this.hasNewUnmapped = this.newUnmappedCount > 0;
    this.smsViewerOpen = false;
    this.selectedSmsThread = null;

    this.selectedEmailPreview = {
      split_req_id: email.split_req_id ? email.split_req_id : null,
      from_email_id: email.from_email,
      subject: email.subject,
      content: email.content,
      created: email.created,
      mailstep: 'View',
      type: email.type,
      attachments: this.normalizeAttachments(
        email?.attachments?.length && typeof email.attachments === 'string'
          ? JSON.parse(email.attachments)
          : email?.attachments?.length
          ? email.attachments
          : []
      )
    };
    this.selectedEmailPreviewHtml = this.sanitizePreviewContent(email?.content || '');
    this.emailViewerOpen = true;
  }

  closeEmailViewer() {
    this.emailViewerOpen = false;
    this.selectedEmailPreview = null;
    this.selectedEmailPreviewHtml = '';
  }
  
  markSmsGroupAsRead(group: any) {
  if (this.selectedTab !== this.tabs.mapped) return;

  //for read
  this.mappedMessages.forEach(msg => {
    if (group.split_req_ids?.includes(msg.split_req_id)) {
      msg.isNew = false;
    }
  });

  //flashing
  group.isNew = false;

  // count flags
  this.hasNewMapped = this.mappedMessages.some(m => m.isNew);
}


  showMoreAccounts(group: any) {
    group.showAllAccounts = !group.showAllAccounts;
  }

  openSmsView(sms: any, event: any) {
      event.stopPropagation();

      // Mark ALL messages in this group as read
      sms.messages.forEach((msg: any) => {
        msg.isNew = false;
      });

      sms.isNew = false;

      const data = {
        from_number: sms.from_number,
        messages: sms.messages, // ← pass entire array
        mailstep: 'View-sms',
        type: 'SMS',
      };

      const sortedMessages = [...(sms?.messages || [])].sort(
        (a: any, b: any) =>
          new Date(a.created).getTime() - new Date(b.created).getTime()
      );

      sortedMessages.forEach((msg: any) => {
        msg.isNew = false;
      });

      sms.messages = sortedMessages;
      this.hasNewUnmapped = this.newUnmappedCount > 0;
      this.emailViewerOpen = false;
      this.selectedEmailPreview = null;
      this.selectedEmailPreviewHtml = '';
      this.selectedSmsThread = {
        ...sms,
        messages: sortedMessages,
      };
      this.smsViewerOpen = true;
  }
  closeSmsViewer() {
    this.smsViewerOpen = false;
    this.selectedSmsThread = null;
  }

  sanitizeHtmlContent(htmlContent: string): string {
    if (!htmlContent) return '';

    let sanitized = htmlContent.replace(/\\n|\\/g, '');
    const isHtml = /<[a-z][\s\S]*>/i.test(sanitized);

    if (isHtml) {
      sanitized = sanitized
        .replace(/<div class="gmail_quote"[\s\S]*$/i, '')
        .replace(/<blockquote[\s\S]*?<\/blockquote>/gi, '')
        .replace(/On[\s\S]*?wrote:(.|\s)*/i, '');
    } else {
      sanitized = sanitized
        .replace(/^reply to the reply.*$/gim, '')
        .replace(/On[\s\S]*?(wrote:|wrote :)(.|\s)*/i, '')
        .replace(/From:.*Sent:.*To:.*Subject:.*/is, '')
        .replace(/^>.*$/gm, '');
    }

    sanitized = sanitized.replace(
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1" target="_blank">$1</a>'
    );

    return sanitized.replace(/(<div>\s*<\/div>)+/g, '').trim();
  }

  sanitizePreviewContent(htmlContent: string): string {
    if (!htmlContent) return '';

    const isHtml = /<[a-z][\s\S]*>/i.test(htmlContent);
    if (isHtml) {
      return this.sanitizer.sanitize(1, this.sanitizeHtmlContent(htmlContent)) || '';
    }

    const maxPlainTextLength = 300;
    if (htmlContent.length > maxPlainTextLength) {
      return this.sanitizer.sanitize(1, this.sanitizeHtmlContent(htmlContent)) || '';
    }

    let sanitized = htmlContent
      .replace(/\\r\\n|\\n|\\r/g, '\n')
      .replace(/\r\n|\r|\n/g, '\n')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    sanitized = sanitized.replace(
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1" target="_blank">$1</a>'
    );

    return sanitized.replace(/\n/g, '<br>').trim();
  }

  normalizeAttachments(list: any[]): { name: string; url: string }[] {
    return (list || [])
      .map((doc: any) => {
        if (doc && typeof doc === 'object' && 'name' in doc && 'url' in doc) {
          return doc;
        }

        if (doc && typeof doc === 'object' && !Array.isArray(doc)) {
          const keys = Object.keys(doc);
          if (keys.length === 1 && typeof doc[keys[0]] === 'string') {
            return { name: keys[0], url: doc[keys[0]] };
          }
        }

        if (typeof doc === 'string') {
          return {
            name: doc.split('/').pop() || 'file',
            url: doc,
          };
        }

        return null;
      })
      .filter(Boolean);
  }

  getFileIcon(docLink: any): string {
    const link = String(docLink ?? '').toLowerCase();

    if (!link) return 'assets/images/svg/file.svg';
    if (link.includes('.pdf')) return 'assets/images/svg/pdf.svg';
    if (link.includes('.csv') || link.includes('.xlsx')) return 'assets/images/svg/excel.svg';
    if (link.includes('.zip')) return 'assets/images/icons/file-zip.svg';
    if (link.includes('.pptx')) return 'assets/images/icons/file-ppt.svg';
    if (link.match(/\.(jpg|jpeg|png|gif|heic|mp4)$/)) return 'assets/images/svg/image.svg';
    if (link.match(/\.(doc|docx|txt)$/)) return 'assets/images/icons/file.svg';

    return 'assets/images/svg/file.svg';
  }

  groupedSms() {
    const map = new Map();

    for (const i of this.mappedMessages ?? []) {
      const sms = String(i?.from_number);

      if (!map.has(sms)) {
        map.set(sms, {
          accountIds: [],
          split_req_ids: [],
          created: i.created,
          isNew: false,
        });
      }

      const g = map.get(sms);

      if (i.isNew) {
        g.isNew = true;
      }

      if (i?.account_id != null && !g.accountIds.includes(i.account_id)) {
        g.accountIds.push(i.account_id);
      }

      if (
        i?.split_req_id != null &&
        !g.split_req_ids.includes(i.split_req_id)
      ) {
        g.split_req_ids.push(i.split_req_id);
      }
    }

    return [...map].map(([from_number, d]) => ({
      from_number,
      created: d.created,
      accountIds: d.accountIds,
      split_req_ids: d.split_req_ids,
      isNew: d.isNew,
      showAllAccounts: false,
    }));
  }

  groupCalls() {
    const map = new Map();

    for (const i of this.mappedCalls ?? []) {
      const call = String(i?.from_number);
      const status = String(i?.call_status);
      const key = `${call}|${status}`; // Composite key: from_number|call_status

      if (!map.has(key)) {
        map.set(key, {
          accountIds: [],
          split_req_ids: [],
          created: i.created,
          isNew: false,
          to_numbers: [],
          call_status: status,
        });
      }

      const g = map.get(key);

      if (i.isNew) {
        g.isNew = true;
      }

      // Keep accountIds and split_req_ids index-aligned so the clicked chip redirects to its own account
      if (i?.account_id != null && !g.accountIds.includes(i.account_id)) {
        g.accountIds.push(i.account_id);
        g.split_req_ids.push(i.split_req_id);
      }

      // Store to_number for reference
      if (i?.to_number != null && !g.to_numbers.includes(i.to_number)) {
        g.to_numbers.push(i.to_number);
      }
    }

    return [...map].map(([key, d]) => {
      const [from_number] = key.split('|');
      return {
        from_number,
        created: d.created,
        accountIds: d.accountIds,
        split_req_ids: d.split_req_ids,
        isNew: d.isNew,
        showAllAccounts: false,
        to_numbers: d.to_numbers,
        call_status: d.call_status,
      };
    });
  }

  timeAgo(dateString: any, topdate?: number): string {

    const date = new Date(dateString);

    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 10) return 'Just now';

    if (seconds < 60) return `${seconds}s ago`;

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  }

 groupUnmappedMessages() {
    const groups: any = {};

    this.unmappedMessages.forEach((msg) => {
      const from = msg.from_number;

      // default like emails
      if (msg.isNew === undefined) {
        msg.isNew = false;
      }

      if (!groups[from]) {
        groups[from] = {
          from_number: from,
          messages: [],
          created: msg.created,
          isNew: false,
        };
      }

      groups[from].messages.push(msg);

      // update created timestamp only
      if (new Date(msg.created) > new Date(groups[from].created)) {
        groups[from].created = msg.created;
      }

      // group flashes ONLY if message is already new
      if (msg.isNew) {
        groups[from].isNew = true;
      }
    });

    this.groupedUnmappedMessages = Object.values(groups);
    console.log("messages", this.groupedUnmappedMessages)
  }

  openUnmapped() {
    this.selectedTab = this.tabs.unmapped;
    this.hasNewUnmapped = false;
    this.hasNewMapped = false;
    this.communicationSearch = '';
  }

  openMapped() {
    this.selectedTab = this.tabs.mapped;
    this.hasNewMapped = false;
    this.communicationSearch = '';
  }

  get newUnmappedCount(): number {
    const newEmailsunmapped = this.unmappedEmails?.filter(x => x.isNew).length || 0;
    const newMessagesunmapped = this.unmappedMessages?.filter(x => x.isNew).length || 0;
    const newCallsunmapped = this.unmappedCalls?.filter(x => x.isNew).length || 0;
    return newEmailsunmapped + newMessagesunmapped + newCallsunmapped;
  }

  get newMappedCount(): number {
    const newEmailsmapped = this.mappedEmails?.filter(x => x.isNew).length || 0;
    const newMessagesmapped = this.mappedMessages?.filter(x => x.isNew).length || 0;
    const newCallsmapped = this.mappedCalls?.filter(x => x.isNew).length || 0;
    return newEmailsmapped + newMessagesmapped + newCallsmapped;
  }

  get newMappedCallsCount(): number {
    return this.mappedCalls?.filter(x => x.isNew).length || 0;
  }

  get newUnmappedCallsCount(): number {
    return this.unmappedCalls?.filter(x => x.isNew).length || 0;
  }

  // Unmapped subtab counts
  get newUnmappedEmailsCount(): number {
    return this.unmappedEmails?.filter(x => x.isNew).length || 0;
  }

  get newUnmappedMessagesCount(): number {
    return this.unmappedMessages?.filter(x => x.isNew).length || 0;
  }

  // Mapped subtab counts
  get newMappedEmailsCount(): number {
    return this.mappedEmails?.filter(x => x.isNew).length || 0;
  }

  get newMappedMessagesCount(): number {
    return this.mappedMessages?.filter(x => x.isNew).length || 0;
  }

markGroupAsRead(group: GroupedEmail) {
  if (this.selectedTab !== this.tabs.mapped) return;

  this.mappedEmails.forEach(email => {
    const belongsToGroup = group.accounts.some(
      acc => acc.accountId === email.account_id
    );

    if (belongsToGroup) {
      email.isNew = false;
    }
  });
  group.isNew = false;
}
calculatedate(group: any[]): string {
  if (!group?.length) return '';

  const createdDate = new Date(group[0].created);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const itemDate = new Date(
    createdDate.getFullYear(),
    createdDate.getMonth(),
    createdDate.getDate()
  );

  const diffTime = today.getTime() - itemDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';

  return `Older`;
}

  // Runs after login and on reload so google_auth_pending reflects the server's
  // admin_gmail_status (0 = inactive, 1 = active).
  private checkGmailStatus() {
    this._api.api({}, 'gmail/state_info', 'get')
      .subscribe({
        next: (response: any) => {
          if (!response || response.is_error !== 0) {
            return;
          }
          this.applyGmailStatus(response.admin_gmail_status);
        },
        error: () => {}
      });
  }

  // Accepts 1/'1'/'active' as active; anything else (incl. missing) is inactive.
  private applyGmailStatus(value: any) {
    const status = (value === 'active' || Number(value) === 1) ? 'active' : 'inactive';
    localStorage.setItem('google_auth_pending', status);
    if (status === 'inactive' && this.requiresGoogleAuth() && !this.showGoogleAuth) {
      // Deferred: this can run inside ngAfterViewInit, where changing bound state throws ExpressionChanged.
      Promise.resolve().then(() => this.openGoogleAuthModal());
    }
  }

  private getRoleId(): number {
    try {
      const profileData = this._local.customGetItem('admin_profile');
      return profileData ? profileData.role_id || 0 : 0;
    } catch {
      return 0;
    }
  }

  private requiresGoogleAuth(): boolean {
    return this.getRoleId() > 4;
  }

  openGoogleAuthModal() {
    this.showGoogleAuth = true;
    document.body.style.overflow = 'hidden';
    this.disableInspect();
  }

  continueWithGoogle() {
    if (this.googleAuthLoading) {
      return;
    }
    // window.open can't send the Authorization header, so the token goes in the query string.
    const token = encodeURIComponent(this._local.customGetItem('token') || '');
    const authUrl = `${environment.baseUrl}gmail/gmail_auth_url?access_token=${token}`;
    localStorage.setItem('gmail_auth_popup', '1');
    const popup = window.open(authUrl, 'gmail_auth', 'width=500,height=650');
    if (!popup) {
      localStorage.removeItem('gmail_auth_popup');
      this._shared.customPopups('Please allow pop-ups for this site and try again.', 1);
      return;
    }
    this.googleAuthLoading = true;
    clearInterval(this.authPopupTimer);
    this.authPopupTimer = setInterval(() => {
      if (popup.closed) {
        // Only unlock the button: popup.closed can read true early once Google's COOP severs the opener,
        // so the result still arrives through onGmailAuthResult.
        clearInterval(this.authPopupTimer);
        this.googleAuthLoading = false;
      }
    }, 500);
  }

  private onGmailAuthResult = (e: StorageEvent) => {
    if (e.key !== 'gmail_auth_result' || !e.newValue) {
      return;
    }
    localStorage.removeItem('gmail_auth_result');
    clearInterval(this.authPopupTimer);
    this.googleAuthLoading = false;
    let result: any = {};
    try {
      result = JSON.parse(e.newValue);
    } catch {}
    if (result.status === 'success') {
      this._shared.customPopups(result.gmail ? `Connected ${result.gmail}` : 'Google account connected', 0);
      this.closeGoogleAuthModal();
      // Re-read the connection state from the server rather than trusting the popup's result alone.
      this.checkGmailStatus();
      return;
    }
    const messages: any = {
      access_denied: 'Google sign-in was cancelled.',
      no_refresh_token: 'Google did not grant offline access. Remove Credee from your Google account permissions and try again.',
      invalid_state: 'Google sign-in expired. Please try again.',
      missing_code: 'Google sign-in did not complete. Please try again.',
      email_mismatch: result.expected
        ? `You need to log in with ${result.expected}. Please try again and choose that Google account.`
        : 'Please connect the Gmail account you use to log in to credee crm.',
      invalid_grant: 'Google sign-in link was already used or expired. Please try again.',
    };
    this._shared.customPopups(messages[result.reason] || 'Google sign-in failed. Please try again.', 1);
  };

  closeGoogleAuthModal() {
    localStorage.setItem('google_auth_pending', 'active');
    this.showGoogleAuth = false;
    document.body.style.overflow = '';
    this.enableInspect();
  }

  ngOnDestroy() {
   window.removeEventListener('storage', this.onGmailAuthResult);
   clearInterval(this.authPopupTimer);
   document.body.style.overflow = '';
 }

}

interface GroupedEmail {
  from_email: string;
  created: any;
  isNew: boolean;
  showAllAccounts: boolean;
  accounts: {
    accountId: any;
    splitReqId: any;
  }[];
}
export interface Notification {
  an_id: number;
  admin_id: number;
  from_type: string;
  from_id: number;
  contract_id: number;
  notification_type: number;
  title: string;
  message: string;
  metadata: string;
  req_id: string;
  action: string;
  read_at: string | null;
  sent_at: string;
  is_deleted: number;
  admin_name: string;
}
